const PRODUCTS = [
  {
    code: "BB-01",
    name: "The Ballboy",
    short:
      "Never chase a ball again. The Ballboy keeps 2–3 pickleballs right where you need them — mounted to your post or wall, always within reach, always ready to play.",
    longer:
      "Built for serious players, clubs, and facilities, the Ballboy is a sleek, 3D-printed holder engineered for both indoor and outdoor courts. It's not just functional — it looks the part.",
    img: "https://customer-assets.emergentagent.com/job_pickletech-supply/artifacts/8ww8vt4c_PXL_20260506_170055850.jpg",
    specs: [
      ["Material", "PETG CF (10% carbon)"],
      ["Weight", "12.5 oz"],
      ["Dimensions", '3.75" × 3.35" × 7.87"'],
      ["Capacity", "2 – 3 balls"],
    ],
    bullets: [
      "Magnetic mount for square posts, round-post clamp, or wall mount",
      "Holds 2–3 pickleballs securely · indoor & outdoor rated",
      "Impact + weather resistant · smooth, easy-clean surface",
      "Heavy-weight, solid construction with a premium aesthetic",
    ],
    footnote:
      "Custom embossing or logo emblem available · additional charges and 15-unit minimum apply.",
  },
  {
    code: "BB-02",
    name: "The Marker",
    short:
      "Commercial-grade 3D printed court number signage. Marble backing with black text — pickleball-themed and built to last.",
    longer:
      "Mounted on wall, fence, or post. Colors and branding can be customized at a premium.",
    img: "https://customer-assets.emergentagent.com/job_pickletech-supply/artifacts/ggwokvwq_PXL_20260506_170207701.jpg",
    specs: [
      ["Material", "PETG"],
      ["Dimensions", '11.811" × 11.811" × 0.1732"'],
      ["Finish", "Marble back / Black text"],
      ["Theme", "Pickleball"],
    ],
    bullets: [
      "Commercial-grade impact resistance",
      "Weather resistant — rated for indoor & outdoor",
      "Pickleball-themed silhouette with high-contrast legibility",
      "Custom colors and facility branding available at a premium",
    ],
    footnote:
      "Custom color match or facility branding available · premium pricing applies.",
  },
];

export default function Products() {
  return (
    <section
      id="products"
      data-testid="products-section"
      className="bg-[#FAFAFA] border-b border-[#E5E5E5]"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 py-20 md:py-28">
        <SectionHeader
          eyebrow="02 / Catalog"
          title="Two products. Built for the way facilities actually run."
          sub="Engineered for facility managers, league directors and tournament ops. Each part is printed-to-order in our US shop."
        />

        <div className="mt-16 grid grid-cols-1 lg:grid-cols-2 border border-[#E5E5E5] bg-white">
          {PRODUCTS.map((p, i) => (
            <article
              key={p.code}
              data-testid={`product-card-${p.code.toLowerCase()}`}
              className={`group relative ${
                i === 0 ? "lg:border-r border-[#E5E5E5]" : ""
              }`}
            >
              <div className="relative aspect-[4/3] overflow-hidden border-b border-[#E5E5E5] bg-[#0A0A0A]">
                <img
                  src={p.img}
                  alt={p.name}
                  className="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-[1.02] transition-all duration-500"
                />
                <div className="absolute top-4 left-4 bg-[#DFFF00] text-[#0A0A0A] px-2.5 py-1 font-mono-bb text-[10px] tracking-widest">
                  {p.code}
                </div>
                <div className="absolute bottom-4 right-4 font-mono-bb text-white/70 text-[10px] tracking-widest">
                  PRINT-TO-ORDER
                </div>
              </div>

              <div className="p-8 md:p-10">
                <h3 className="font-display text-2xl md:text-3xl tracking-tight font-medium">
                  {p.name}
                </h3>
                <p className="mt-3 text-[15px] text-[#525252] leading-relaxed">
                  {p.short}
                </p>
                {p.longer && (
                  <p className="mt-3 text-[14px] text-[#525252] leading-relaxed">
                    {p.longer}
                  </p>
                )}

                <ul className="mt-7 space-y-2.5">
                  {p.bullets.map((b) => (
                    <li
                      key={b}
                      className="flex items-start gap-3 text-[14px] text-[#0A0A0A]"
                    >
                      <span className="mt-2 w-1.5 h-1.5 bg-[#DFFF00] shrink-0" />
                      {b}
                    </li>
                  ))}
                </ul>

                <div className="mt-8 grid grid-cols-2 border-t border-[#E5E5E5]">
                  {p.specs.map(([k, v]) => (
                    <div
                      key={k}
                      className="border-b border-r border-[#E5E5E5] last:border-r-0 even:border-r-0 py-3 pr-3"
                    >
                      <div className="overline text-[#525252]">{k}</div>
                      <div className="font-mono-bb text-[13px] mt-1">{v}</div>
                    </div>
                  ))}
                </div>

                {p.footnote && (
                  <p className="mt-5 font-mono-bb text-[11px] tracking-wide text-[#525252] leading-relaxed">
                    // {p.footnote}
                  </p>
                )}
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-between gap-4 font-mono-bb text-[11px] text-[#525252] tracking-widest">
          <span>// MORE SKUS IN DEVELOPMENT — TELL US WHAT YOUR FACILITY NEEDS.</span>
          <a
            href="#quote"
            data-testid="products-suggest-link"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector("#quote")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="text-[#0A0A0A] hover:text-[#0055FF] transition-colors"
          >
            SUBMIT A CUSTOM REQUEST →
          </a>
        </div>
      </div>
    </section>
  );
}

export function SectionHeader({ eyebrow, title, sub }) {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-12 items-end">
      <div className="lg:col-span-4">
        <div className="overline text-[#525252]">{eyebrow}</div>
      </div>
      <div className="lg:col-span-8">
        <h2 className="font-display text-3xl sm:text-4xl lg:text-[44px] leading-[1.05] tracking-tight font-medium max-w-3xl">
          {title}
        </h2>
        {sub && (
          <p className="mt-5 text-[15px] text-[#525252] leading-relaxed max-w-2xl">
            {sub}
          </p>
        )}
      </div>
    </div>
  );
}
